export function validate(valids, itemNumber) {
    return valids.includes(itemNumber);
}